// Returns the string capitalized
export default function (value) {
  if (!value) return "";
  const escaped = value.replace(/"/g, '\\"');
  return escaped;
}
